import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export function useResetToHome() {
  const navigate = useNavigate();

  const resetToHome = useCallback(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return { resetToHome };
}
